import { Container } from '@mui/material';
import { NotFoundLayout } from './components';

export default function NotFoundPage() {
  return (
    <Container maxWidth="xl" sx={{ marginTop: '30vh' }}>
      <NotFoundLayout />
    </Container>
  );
}
